module.exports = __webpack_public_path__ + "static/media/hearclearpro-1.01664111.jpg";